import { render, staticRenderFns } from "./createdVr.vue?vue&type=template&id=123ec045&scoped=true"
import script from "./createdVr.vue?vue&type=script&lang=js"
export * from "./createdVr.vue?vue&type=script&lang=js"
import style0 from "./createdVr.vue?vue&type=style&index=0&id=123ec045&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ec045",
  null
  
)

export default component.exports